import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { StartGrid } from "@/components/StartGrid";
import { DiceSystem } from "@/components/DiceSystem";
import { FAQ } from "@/components/FAQ";
import { Community } from "@/components/Community";

export const Landing = () => (
  <>
    <Hero />
    <Features />
    <StartGrid />
    <DiceSystem />
    <FAQ />
    <Community />
  </>
);
